
define('text!modules/reporting/campaigns/siteTransparency/templates/subitem.html',[],function () { return '{{#list}}\n<li class="stack">\n  {{#keys}}\n  <div class="column detail {{ format }} {{ key }} {{^isName}}text{{/isName}}">{{{value}}}</div>\n  {{/keys}}\n</li>\n{{/list}}\n';});

